import { t } from "@/i18n-js/instance";
import { CustomizeSpaceSectionSelector } from "@/react/components/Spaces/CustomizeSpaceFullPage/CustomizeSpaceSectionSelector";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { Space } from "@/react/types/Space";
import { Layout } from "@circle-react-shared/CustomizeUI";
import { useCustomizeUIData } from "@circle-react-shared/CustomizeUI";
import { MobileNotSupportedPanel } from "@circle-react-shared/MobileNotSupportedPanel";

interface CustomizeSpaceLayoutProps {
  onClose: () => void;
  scrollToId?: string;
  space: Space;
}

export const CustomizeSpaceLayout = ({
  space,
  scrollToId,
  onClose,
}: CustomizeSpaceLayoutProps) => {
  const { currentSection } = useCustomizeUIData();
  const isLockscreen = currentSection === t("customize_space.lock_screen");

  const variant = !isLockscreen ? "only-main" : "no-header";

  return (
    <>
      <Layout
        variant={variant}
        className={classNames({
          "hidden lg:grid": isLockscreen,
        })}
      >
        <CustomizeSpaceSectionSelector
          space={space}
          scrollToId={scrollToId}
          onClose={onClose}
        />
      </Layout>
      {isLockscreen && (
        <MobileNotSupportedPanel
          className="lg:hidden"
          title={t("courses.lockscreen.mobile_unsupported.title")}
          description={t("courses.lockscreen.mobile_unsupported.description")}
        />
      )}
    </>
  );
};
